<template>
  <v-row>
    <!--Declaration -->
    <v-col sm="12" md="12" class="p-5">
      <!--General Information-->
      <v-card>
        <div class="form-group">
          <v-card-title> Declaration </v-card-title>
          <v-card-text>
            <div
              v-html="termsAndConditions?.termsAndConditions"
              style="max-height: 500px; overflow-y: auto"
              class="pa-4 border rounded declaration-text"
            ></div>
          </v-card-text>
        </div>

        <v-form v-model="isValid" ref="submitForm">
          <v-checkbox
            v-model="accepted"
            :true-value="true"
            :false-value="false"
            color="primary"
            class="mx-5"
            :rules="rules.required"
          >
            <template v-slot:label> I agree to the above declaration </template>
          </v-checkbox>
        </v-form>

        <v-card-actions>
          <v-btn @click="back" class="btn-secondary">
            <v-icon> mdi-arrow-left</v-icon>
            Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="submit"
            :disabled="!accepted || !application"
            color="primary"
          >
            Submit
            <v-icon> mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import setupMixin from "../../setup/SetupMixin";

export default {
  name: "Declaration",
  mixins: [setupMixin],
  props: { next: { type: Function }, back: { type: Function } },
  data() {
    return {
      accepted: null,
      isValid: false,
    };
  },

  mounted() {
    this.getSetups(["TermsAndCondition"]);
    Event.$on("License-saved", () => {
      this.$router.push(`/license`);
    });

    const cacheApp = window.localStorage.getItem(
      "License_Application_ebk_asteria"
    );
    if (cacheApp) {
      this.$store.commit("License/MUTATE", {
        state: "application",
        data: { ...JSON.parse(cacheApp) },
      });
    }
    if (this.$route.query.tab) {
      this.tab = parseInt(this.$route.query?.tab ?? "0");
    }
  },

  computed: {
    rules() {
      return {
        required: [(value) => !!value || "Required field"],
      };
    },

    application() {
      return this.$store.getters["License/licenseGetters"]("application");
    },
  },

  methods: {
    submit: function () {
      this.$route.params.code
        ? this.$store.dispatch("License/updateApplication", {
            city: this.application.city,
            countryCode: this.application.countryCode,
            county: this.application.county,
            email: this.application.email,
            licenseApplicationNo: this.$route.params.code,
            phoneNo: this.application.phoneNo,
            physicalLocation: this.application.physicalLocation,
            postalCode: this.application.postalCode,
            practiceName: this.application.practiceName,
            practitionerAddress: this.application.practitionerAddress,
            practitionerEmail: this.application.practitionerEmail,
            practitionerOtherNames: this.application.practitionerOtherNames,
            practitionerPhone: this.application.practitionerPhone,
            practitionerSurname: this.application.practitionerSurname,
            submitted: true,
          })
        : this.$store.dispatch("License/submitApplication", {
            ...this.application,
          });
    },
  },
};
</script>

<style scoped>
.declaration-text >>> img {
  max-width: 100%;
  height: auto !important;
}
</style>
